import React from "react";
import { string, array, object } from "prop-types";
import PlatformChips from "./PlatformChips";
import ItemBadges from "./ItemBadges";

import analytics from "shared/analytics";
import { cardHover } from "../component-styles";
import { Box, Link, Typography } from "@mui/material";

const DocumentCard = (props) => {
  const { doc, docTitle, docDescription, docUrl, platformTags } = props;

  const handleClick = () => {
    analytics.trackDocument(`document_resource: ${docTitle}`);
  };

  return (
    <Box
      component="article"
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "1rem",
        color: theme.palette.secondary.main,
        borderRadius: 1,
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: theme.palette.secondary.light,
        padding: "1rem",
        width: "100%",
        position: "relative",
        ...cardHover(theme.palette),
      })}
    >
      <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <Link
          href={docUrl}
          target="_blank"
          onClick={handleClick}
          underline="none"
          sx={(theme) => ({
            color: theme.palette.secondary.main,
            display: "block",
            fontSize: 22,
            marginRight: "1rem",
            "&:hover": {
              textDecoration: "none",
            },
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          })}
        >
          {docTitle}
        </Link>
        <ItemBadges item={doc} positioned={false} />
      </Box>
      <Typography sx={{ color: "black" }}>{docDescription}</Typography>
      <Box sx={{ position: "relative", alignSelf: "flex-start" }}>
        {platformTags.length > 0 && (
          <PlatformChips chips={platformTags} style={{ flexWrap: "wrap" }} />
        )}
      </Box>
    </Box>
  );
};

DocumentCard.defaultProps = {
  docTitle: "",
  docDescription: "",
  docUrl: "",
  platformTags: [],
};

DocumentCard.propTypes = {
  doc: object,
  docTitle: string,
  docDescription: string,
  docUrl: string,
  platformTags: array,
};

export default DocumentCard;
